/**
 * Part of starter project.
 *
 * @copyright  Copyright (C) 2021 LYRASOFT.
 * @license    __LICENSE__
 */
document.addEventListener('DOMContentLoaded', () => {
    // swiper
    let gmaPhotoSwiper = new Swiper('.j-gma-swiper', {
        spaceBetween: 20,
        breakpoints: {
            768: {
                slidesPerView: 3,
            },
        },
        navigation: {
            nextEl: '.j-gma-next',
            prevEl: '.j-gma-prev',
        },
    });

    let gmaMediaSwiper = new Swiper('.j-media-swiper', {
        spaceBetween: 20,
        breakpoints: {
            768: {
                slidesPerView: 3,
            },
        },
        navigation: {
            nextEl: '.j-media-next',
            prevEl: '.j-media-prev',
        },
    });

    // accordion 跳轉 link
    for (let i = 1; i <= 3; i++) {
        if (document.getElementById('flush-heading-0' + i)) {
            let accordion = (document.getElementById('flush-heading-0' + i)) ? document.getElementById('flush-heading-0' + i) : null;
            let articleHeading = (document.getElementById('article-heading-0' + i)) ? document.getElementById('article-heading-0' + i) : null;

            accordion.addEventListener('click', function () {
                window.location = '#' + articleHeading.id;
            });
        } else {
            return;
        }
    }

    // 跳轉 gma project articles
    function handleWaypoint(articleNumber) {
        $('.accordion-button').addClass('collapsed');
        $('.accordion-collapse').removeClass('show');
        $(`#accordion-button-${articleNumber}`).removeClass('collapsed');
        $(`#flush-collapse-${articleNumber}`).addClass('collapse show');
    }

    let articles = document.getElementsByClassName('c-project-card');
    for (let i = 0; i < articles.length; i++) {
        new Waypoint.Inview({
            element: articles[i],
            entered: function (direction) {
                handleWaypoint('0' + (i + 1));
            },
            continuous: false
        });
    }
});
